import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export const keyCommunityEvent: BaseKeyFunction<string> = (eventId) => [
  "community-event",
  eventId,
];
